import { CalendarClock, Zap } from "lucide-react";

// Renders a course's `events` list — dated batches and paid demo sessions.
// No payment is taken here; a demo fee is confirmed and collected directly,
// the same as every other fee on the site.
export default function EventsStrip({ events, onEnquire, testId = "events-strip" }) {
  if (!events || events.length === 0) return null;
  return (
    <div data-testid={testId} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {events.map((ev, i) => {
        const isDemo = ev.kind === "demo";
        return (
          <div
            key={i}
            data-testid={`${testId}-item-${ev.kind}`}
            className={`rounded-2xl border p-6 flex flex-col ${
              isDemo ? "border-terracotta/40 bg-terracotta/5" : "border-line bg-surface"
            }`}
          >
            <div className={`flex items-center gap-2 ${isDemo ? "text-terracotta" : "text-emerald"}`}>
              {isDemo ? <Zap size={16} /> : <CalendarClock size={16} />}
              <span className="font-sans text-xs font-bold uppercase tracking-wide">{ev.title}</span>
              {ev.fee && (
                <span className="ml-auto font-sans text-xs font-bold text-terracotta bg-white rounded-full px-2.5 py-1 border border-terracotta/30">
                  {ev.fee}
                </span>
              )}
            </div>
            <p className="font-display font-bold text-xl md:text-2xl text-ink mt-3 leading-tight">
              {ev.date_label}
            </p>
            {ev.note && (
              <p className="font-sans text-[15px] text-graphite mt-2 leading-relaxed">{ev.note}</p>
            )}
            {onEnquire && (
              <button
                type="button"
                onClick={onEnquire}
                data-testid={`${testId}-cta-${ev.kind}`}
                className={`mt-4 self-start rounded-full font-sans text-sm font-bold px-5 py-2.5 transition-colors ${
                  isDemo
                    ? "bg-terracotta text-white hover:bg-terracottahover"
                    : "border border-emerald text-emerald hover:bg-emeraldlight"
                }`}
              >
                {isDemo ? `Register — ${ev.fee}` : "Enquire to hold a seat"}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
